import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { ChannelTile } from "../ChannelTile";
import { ReactComponent as TwilioIcon } from "./assets/twilio.svg";

export const TwilioTile: React.FC<{
  isSelected: boolean;
  onSelect: () => void;
}> = (props) => {
  const { t } = useTranslations();
  const { crmConfig, openManageAccountDrawer } = useManageAccountsDrawer();

  const config = crmConfig?.twilio;

  return (
    <ChannelTile
      title={t({
        id: "common.twilio",
        defaultMessage: "Twilio",
      })}
      isConnected={!!config?.id}
      onClick={() =>
        config?.id
          ? openManageAccountDrawer({ name: "connectedAccountList" })
          : openManageAccountDrawer({ name: "twilioAccount" })
      }
      description={
        config?.id
          ? config.phone_num
          : t({
              id: "cx-ai-agents-page.twilio-connect-description",
              defaultMessage:
                "Connect Twilio to install and preview this channel",
            })
      }
      icon={<TwilioIcon />}
      pillText={
        config?.id
          ? t({
              id: "common.connected",
              defaultMessage: "Connected",
            })
          : undefined
      }
      {...props}
    />
  );
};
